import { Component, computed, input } from '@angular/core';
import { NgClass } from '@angular/common';

export type ThemeColor = 'primary' | 'secondary' | 'tertiary' | 'flat';

@Component({
  selector: 'maximizer-circle-button',
  template: `
    <button
      [class]="classes()"
      [ngClass]="{
        'flex justify-center items-center rounded-full': true,
        'pointer-events-none cursor-not-allowed': disabled(),
        'hover:cursor-pointer': !disabled(),
      }"
      [disabled]="disabled()"
      [attr.aria-disabled]="disabled()"
      [attr.aria-label]="ariaLabel()"
    >
      <span [ngClass]="iconClasses()"></span>
    </button>
  `,
  imports: [NgClass],
})
export class CircleButtonComponent {
  themeColor = input<ThemeColor>('primary');
  ariaLabel = input<string>();
  iconSize = input('16');
  iconStyle = input<string>();
  iconFamily = input('fa');
  icon = input<string>();
  disabled = input<boolean>();
  size = input<'extraSmall' | 'small' | 'medium' | 'large'>('medium');

  iconClasses = computed(() => {
    const iconStyleClass = this.iconStyle() ? `icon-${this.iconStyle()}` : '';
    const iconClass = this.icon() ? `icon-${this.icon()}` : '';
    return `${this.iconFamily()}-icons icon-${this.iconSize()} ${iconStyleClass} ${iconClass}`.trim();
  });

  sizeClasses = computed(() => {
    switch (this.size()) {
      case 'extraSmall':
        return 'w-7 h-7';
      case 'small':
        return 'w-8 h-8';
      case 'large':
        return 'w-12 h-12';
      case 'medium':
      default:
        return 'w-9 h-9';
    }
  });

  themeClasses = computed(() => {
    switch (this.themeColor()) {
      case 'primary':
        return 'bg-primary-100 text-bush-green-140 hover:shadow-circle hover:bg-primary-120 active:bg-primary-140 focus:bg-primary-120 focus:border focus:border-bush-green-140 focus:shadow-circle disabled:bg-neutral-30 disabled:text-neutral-60';
      case 'secondary':
        return 'bg-white border border-primary-120 text-bush-green-140 hover:bg-primary-40 active:bg-primary-80 focus:bg-primary-40 disabled:border-neutral-40 disabled:text-neutral-40';
      case 'tertiary':
        return 'shadow-circle bg-white text-bush-green-140 hover:bg-primary-40 active:bg-primary-80 focus:bg-primary-40 focus:border-2 focus:border-primary-120 disabled:text-neutral-40';
      case 'flat':
        return 'bg-transparent text-bush-green-140 hover:shadow-circle focus-visible:bg-primary-40 focus-visible:shadow-circle disabled:text-neutral-40';
      default:
        return '';
    }
  });

  classes = computed(() => {
    return `${this.sizeClasses()} ${this.themeClasses()}`;
  });
}
